"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdpDisconnectRequestStruct = void 0;
const superstruct_1 = require("superstruct");
exports.SdpDisconnectRequestStruct = (0, superstruct_1.type)({
    organisationId: (0, superstruct_1.string)(),
    placeId: (0, superstruct_1.string)(),
    printerId: (0, superstruct_1.string)(),
});
//# sourceMappingURL=SdpDisconnectRequest.js.map